module.exports = __webpack_public_path__ + "static/16-3-bf4efae5714649282eb1a739ee0f29b9.jpg";